/** @jsx jsx */
import { jsx } from '@emotion/core';

import { request, buttonStyles, outerWrap, innerWrap } from './getInTouchStyles';

import Button from '../../components/ui/Button';

export default function GetInTouch() {
  return (
    <div css={outerWrap}>
      <div css={request}>Let's get in touch</div>
      <div css={innerWrap}>
        <Button styles={buttonStyles} to='/contact-us' text='Contact Us' />
      </div>
    </div>
  );
}
